import { connect } from 'react-redux'
import { useState, useEffect } from 'react'
import { ChangePassword, ChangelogButton } from 'Components'
import { useLocation, useHistory } from 'react-router-dom'
import {
  Space
  Modal
  Row
  Col
  Menu
  Button
  Layout
  Tooltip
  Popover
  Avatar
} from 'antd'
import Feather from '@sysunite/react-feather'
import './MainSider.scss'
import WeaverService from 'Services/WeaverService'
import ACLService from 'Services/ACL_Service'
import { setCreatingNode } from 'Actions/explore'

{ Sider } = Layout

MainSider = ({ user, currentProject, darkModeEnabled, children, setCreatingNode }) ->

  [hasAccessToAcl, setHasAccessToAcl] = useState(false)
  [collapsed, setCollapsed] = useState(true)
  [active, setActive] = useState()
  [open, setOpen] = useState([])
  [changePassword, setChangePassword] = useState(false)

  history = useHistory()
  location = useLocation()

  useEffect(->
    (->
      requiredAcls = [
        "project-administration"
      ]
      userAcls = await ACLService.loadUserAclPermissions()
      access = requiredAcls.every((acl) -> userAcls.indexOf(acl) isnt -1);
      setHasAccessToAcl(access)
    )()
    undefined
  , [])


  navItems = [{
    title: 'Explore'
    menuCollapsed: true
    key: 'home'
    route: "/#{currentProject}"
    icon: <Feather type="copy" />
  }, {
    title: 'Version control'
    key: 'version-control'
    requiresAuth: true
    requiresWrite: false
    icon: <Feather type="git-branch" />
    subMenu: [{
      title: 'Branches'
      key: 'branches'
      route: "/#{currentProject}/branches"
      icon: <Feather type="git-branch" />
    }, {
      title: 'Merge requests'
      key: 'merge-requests'
      route: "/#{currentProject}/merge-requests"
      icon: <Feather type="git-pull-request" />
      requiresWrite: true
    }, {
      title: 'Commit tree'
      key: 'commit-tree'
      icon: <Feather type="git-commit" />
      route: "/#{currentProject}/commit-tree"
    }, {
      title: 'Compare branches'
      key: 'compare-branches'
      icon: <Feather type="columns" />
      route: "/#{currentProject}/compare"
      requiresWrite: true
    }]
  }, {
    title: 'Space settings'
    key: 'settings'
    icon: <Feather type="settings" />
    requiresAuth: true
    subMenu: [{
      title: 'Data'
      key: 'space-settings-data'
      icon: <Feather type="database" />
      route: "/#{currentProject}/settings/data"
    }, {
      title: 'Services'
      key: 'space-settings-services'
      icon: <Feather type="cloud" />
      route: "/#{currentProject}/settings/services"
    }, {
      title: 'Views'
      key: 'space-settings-views'
      icon: <Feather type="copy" />
      route: "/#{currentProject}/settings/views"
    }, {
      title: 'Forms'
      key: 'space-settings-forms'
      icon: <Feather type="clipboard" />
      route: "/#{currentProject}/settings/forms"
    }]
  }, {
    title: 'Users and Spaces'
    requiresAdmin: true
    key: 'acl-settings'
    icon: <Feather type="users" />
    subMenu: [{
      title: 'Domains'
      key: 'acl-all-domains'
      icon: <Feather type="globe" />
      route: '/acl/domains'
    }, {
      title: 'All spaces'
      key: 'acl-all-spaces'
      icon: <Feather type="database" />
      route: '/acl/spaces'
    }, {
      title: 'All users'
      key: 'acl-all-users'
      icon: <Feather type="user" />
      route: '/acl/users'
    }, {
      title: 'User groups'
      key: 'acl-user-groups'
      icon: <Feather type="users" />
      route: '/acl/groups'
    }, {
      title: 'Global permissions'
      key: 'acl-global-permissions'
      icon: <Feather type="key" />
      route: '/acl/permissions'
    }]
  }, {
    title: 'Pipelines'
    key: 'pipelines'
    icon: <Feather type="activity" />
    requiresAuth: true
    requiresWrite: true
    subMenu: [{
      title: 'Tasks'
      key: 'pipelines-tasks'
      icon: <Feather type="list" />
      route: "/#{currentProject}/pipelines/tasks"
    }, {
      title: 'Create Task'
      key: 'pipelines-create-task'
      icon: <Feather type="plus" />
      route: "/#{currentProject}/pipelines/tasks/new"
    }]
  }]

  useEffect(->
    search = (items) ->
      _.findLast(items, ({ route, subMenu }) ->
        location.pathname.startsWith(route)
      )

    for item in navItems
      if item.subMenu? and result = search(item.subMenu)
        break

    unless result
      result = search(navItems)

    setActive(result?.key)
    setCollapsed(result?.menuCollapsed or false)
    setCreatingNode(false)
    undefined
  , [location])

  generateMenu = ({ menuCollapsed = false, key, title, subMenu, icon, route }) ->
    if subMenu?
      <Menu.SubMenu
        key={key}
        title={title}
        data-testid={key}
        icon={<span className="anticon">{ icon }</span>}
      >
        {
          subMenu.filter(({ requiresWrite }) ->
            if requiresWrite
              ACLService.hasWriteAccess()
            else
              true
          ).map(generateMenu)
        }
      </Menu.SubMenu>
    else
      <Menu.Item
        key={key}
        title={title}
        data-testid={key}
        icon={<span className="anticon">{ icon }</span>}
        onClick={->
          setCollapsed(menuCollapsed)
          history.push(route)
        }
      >
        { title }
      </Menu.Item>

  popoverContent =
    <Space direction="vertical">
      <Button
        onClick={-> setChangePassword(true)}
        type="text"
        icon={<span className="anticon"><Feather type="key" /></span>}
      >
        Change password
      </Button>
      <Button
        onClick={->
          await WeaverService.logout()
          history.push('/login')
        }
        type="text"
        data-testid="logout"
        icon={<span className="anticon"><Feather type="log-out" /></span>}
      >
        Logout
      </Button>
    </Space>

  <>
    {
      unless location.pathname.includes('login') or location.pathname.includes('signup')
        <Sider
          theme={darkModeEnabled && 'dark' || 'light'}
          collapsed={collapsed}
          collapsedWidth={63}
          width={250}
          style={{ zIndex: 3 }}
        >
          <div className="main-sider">
            <ChangelogButton collapsed={collapsed} />
            <Menu
              style={{ borderRight: 0 }}
              mode="inline"
              theme={darkModeEnabled && 'dark' || 'light'}
              selectedKeys={[ active ]}
              openKeys={open}
              onOpenChange={setOpen}
            >
              {
                navItems.filter(({ requiresWrite, requiresAuth, requiresAdmin }) ->
                  if requiresAdmin
                    hasAccessToAcl
                  else if requiresWrite
                    ACLService.hasWriteAccess()
                  else if requiresAuth
                    WeaverService.isAuthenticated()
                  else
                    true
                ).map(generateMenu)
            }
            </Menu>
            <div className="spacer" />
            <Button
              type="text"
              onClick={-> window.open('https://support.weaverhq.com/', '_blank')}
              icon={<span className="anticon"><Feather type='book' /></span>}
            />
            <Button
              data-testid="support-button"
              type="text"
              style={{ margin: '8px 0px' }}
              onClick={-> FreshworksWidget('open')}
              icon={<span className="anticon"><Feather type='message-square' /></span>}
            />
            {
              if WeaverService.isAuthenticated()
                <Popover
                  placement="right"
                  content={popoverContent}
                >
                  <Row style={{
                      width: unless collapsed then '100%'
                      paddingLeft: unless collapsed then '16px'
                      cursor: 'pointer'
                    }}
                    data-testid="user-avatar-container"
                    justify="center"
                    align="middle"
                    gutter={8}
                  >
                    <Col>
                      <Avatar>{ Weaver.getInstance().currentUser().firstname?[0] }</Avatar>
                    </Col>
                    {
                      unless collapsed
                        <Col flex={1}>
                          <b>
                            { "#{WeaverService.getUsername().firstname} #{WeaverService.getUsername().lastname}" }
                          </b>
                        </Col>
                    }
                  </Row>
                </Popover>
              else
                <Tooltip placement="right" title="Log in">
                  <Button
                    onClick={->
                      history.push('/login')
                    }
                    type="text"
                    shape="circle"
                    icon={<Feather type="log-in" />}
                    data-testid="login"
                  />
                </Tooltip>
                }
          </div>
        </Sider>
    }
    { children }
    <Modal
      title="Change Password"
      width={600}
      visible={changePassword}
      footer={null}
      destroyOnClose={true}
      onCancel={-> setChangePassword(false)}
    >
      <ChangePassword
        user={Weaver.getInstance().currentUser()}
        closeModal={-> setChangePassword(false)} />
    </Modal>
  </>

mapStateToProps = ({ user, projects, explore }) ->
  {
    currentProject: projects.currentProject
    darkModeEnabled: explore.darkModeEnabled
    user
  }

export default connect(mapStateToProps, { setCreatingNode })(MainSider)
